// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__aH5ni","logo-title":"Logo_logo-title__BzjB+","textColor":"Logo_textColor__EvjLH"};